import { css } from 'lit';
export default css `
  :host > wui-grid {
    max-height: 360px;
    overflow: auto;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }
`;
//# sourceMappingURL=styles.js.map